var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-button',{attrs:{"custom-icon":_vm.value ? 'fa fa-search-minus' : 'fa fa-search-plus',"text":_vm.value ? 'less' : 'more',"ghost":""},on:{"on-click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }